import type { FC, ReactNode } from 'react';

import cn from 'classnames';

type StickyComposerFooterProps = {
  isVisible: boolean;
  children: ReactNode;
};

export const StickyComposerFooter: FC<StickyComposerFooterProps> = ({ isVisible, children }) => {
  return (
    <div className="fixed inset-x-0 bottom-0 z-20 w-full pointer-events-none md:sticky md:inset-x-auto">
      <div
        aria-hidden={isVisible ? undefined : true}
        className={cn(
          'flex justify-center px-4 py-4 pb-[max(1rem,env(safe-area-inset-bottom))]',
          'transition-[opacity,transform] duration-300 ease-out',
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4',
        )}
      >
        {children}
      </div>
    </div>
  );
};
